export const geogUSCenter = { lat: 39.8283, lng: -98.5795 };
